<template>
  <div class="thank-you">
    <HeaderComponent/>
    <section id="payments" class="payments">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h2>Thank You</h2>
          <p>Your mobile has been recharged successfully.</p>
        </div>
      </div>
    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from "@/components/HeaderPayment"
import FooterComponent from "@/components/Footer"
export default {
  name: "ThankYou",
  components: {
    HeaderComponent,
    FooterComponent
  },
}
</script>

<style scoped>
.thank-you {
  margin-top: 40px;
}
</style>